import linkSvg from './link.svg';
import ticketSvg from './ticket.svg';
import cinemaSvg from './cinema.svg';
import dollarSvg from './ecommerce_receipt_dollar.svg';

export const connectionProps = {
  color: 'purple',
  category: 'connection',
  title: 'Connection',
  description: 'Allow best-fit students to connect with your institution.',
  buttonLabel: 'Manage',
  image: linkSvg,
  link: '/am-plus/view-connections',
};

export const nextGenConnectionProps = {
  color: 'purple',
  category: 'connection',
  title: 'Connection',
  description: 'Allow best-fit students to connect with your institution.',
  buttonLabel: 'Manage',
  image: linkSvg,
  link: '/connection/',
};

export const eventProps = {
  color: 'darkcyan',
  category: 'presence',
  title: 'Events',
  description: 'Manage college events and publish within Naviance.',
  buttonLabel: 'Publish',
  image: ticketSvg,
  link: '/am-events/',
};

export const collegeEventProps = {
  color: 'darkcyan',
  category: 'presence',
  title: 'Events',
  description: 'Manage college events and publish within Naviance.',
  buttonLabel: 'Publish',
  image: ticketSvg,
  link: '/college-events/',
};

export const advAwareProps = {
  color: 'blue',
  category: 'awareness',
  title: 'Advanced Awareness',
  description: 'Ensure best-fit students are seeing your messages as they research college options.',
  buttonLabel: 'Configure',
  image: cinemaSvg,
  link: '/advanced-awareness/',
};

export const scholarshipsProps = {
  color: 'blue',
  category: 'awareness',
  title: 'Scholarships',
  description: 'Highlight merit-based scholarship opportunities and present them to students who fit your eligibility criteria.',
  buttonLabel: 'Publish',
  image: dollarSvg,
  link: '/college-scholarships/',
};
